import React from 'react';
import Loading from 'components/_common/Loading';

const TripFeeUpdateV = ({ params, setParams, handleChange, isUpdate, submit, remove }) => (
    <>
        {params.isLoaded && params.error == null ? (
            <>
                <div className="content-header">
                    <h1>
                        <font>출장비 관리</font>
                    </h1>
                </div>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{isUpdate ? '출장비 수정' : '출장비 등록'}</h3>

                            <div className="card-tools"></div>
                        </div>
                        <div className="g_update p-0 mt_30">
                            <table className="g_table table_type1">
                                <colgroup>
                                    <col width="20%" />
                                    <col width="80%" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>
                                            <label>타입 <span className="required">*</span></label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <select
                                                    className="form-control input-sm"
                                                    onChange={(e) => handleChange(e, 'item.type', setParams, params)}
                                                    value={params.item.type || 'province'}
                                                >
                                                    <option value="province">도 (출장비 - 고객 청구)</option>
                                                    <option value="city">지역 (출장 비용 - 출장자 지불)</option>
                                                </select>
                                                <small className="text-muted">
                                                    도: 고객에게 청구하는 출장비 기본 금액 / 지역: 출장자가 지불해야 하는 비용
                                                </small>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>
                                                {params.item.type === 'province' ? '도명' : '지역명'}
                                                <span className="required">*</span>
                                            </label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="text"
                                                    onChange={(e) => handleChange(e, 'item.name', setParams, params)}
                                                    value={params.item.name || ''}
                                                    placeholder={
                                                        params.item.type === 'province'
                                                            ? '도명을 입력해 주세요. 예: 경기, 서울, 부산'
                                                            : '지역명을 입력해 주세요. 예: 수원시, 성남시'
                                                    }
                                                    maxLength={50}
                                                />
                                                <small className="text-muted">
                                                    {params.item.type === 'province'
                                                        ? '예시: 경기, 서울, 부산, 인천, 대구, 대전, 광주, 울산, 강원, 충북, 충남, 전북, 전남, 경북, 경남, 제주, 세종'
                                                        : '예시: 수원시, 성남시, 용인시, 안양시 등'}
                                                </small>
                                            </div>
                                        </td>
                                    </tr>

                                    {params.item.type === 'province' && (
                                        <tr>
                                            <th>
                                                <label>출장비 (고객 청구) <span className="required">*</span></label>
                                            </th>
                                            <td>
                                                <div className="inner">
                                                    <input
                                                        className="form-control input-sm"
                                                        type="number"
                                                        onChange={(e) => handleChange(e, 'item.tripFee', setParams, params)}
                                                        value={params.item.tripFee || ''}
                                                        placeholder="고객에게 청구할 출장비를 입력해 주세요."
                                                        min="0"
                                                        step="1000"
                                                    />
                                                    <small className="text-muted">고객에게 청구하는 출장비 기본 금액 (원)</small>
                                                </div>
                                            </td>
                                        </tr>
                                    )}

                                    {params.item.type === 'city' && (
                                        <tr>
                                            <th>
                                                <label>출장 비용 (출장자 지불) <span className="required">*</span></label>
                                            </th>
                                            <td>
                                                <div className="inner">
                                                    <input
                                                        className="form-control input-sm"
                                                        type="number"
                                                        onChange={(e) => handleChange(e, 'item.tripCost', setParams, params)}
                                                        value={params.item.tripCost || ''}
                                                        placeholder="출장자가 지불할 비용을 입력해 주세요."
                                                        min="0"
                                                        step="1000"
                                                    />
                                                    <small className="text-muted">출장자가 지불해야 하는 비용 (원)</small>
                                                </div>
                                            </td>
                                        </tr>
                                    )}

                                    <tr>
                                        <th>
                                            <label>메모</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    onChange={(e) => handleChange(e, 'item.note', setParams, params)}
                                                    value={params.item.note || ''}
                                                    placeholder="메모를 입력해 주세요. (선택사항)"
                                                    maxLength={500}
                                                />
                                                <small className="text-muted">추가 설명이나 특이사항을 입력하세요. (최대 500자)</small>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="card-footer">
                            <a
                                className="btn btn-success float-left"
                                onClick={() => {
                                    history.back();
                                }}
                            >
                                <i className="fas fa-long-arrow-left mr_10"></i>이전
                            </a>

                            <button type="button" onClick={submit} className="btn btn-primary float-right">
                                {isUpdate ? '수정' : '등록'}
                            </button>
                            {isUpdate && (
                                <button type="button" onClick={remove} className="btn btn-danger float-right mr_10">
                                    삭제
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </>
        ) : (
            <Loading />
        )}
    </>
);

export default TripFeeUpdateV;